module.exports = __webpack_public_path__ + "img/75322B_96463F_51201A_3D1814-256px.b5a0956c.png";